/**
 * Created by roy on 18/05/2017.
 */

// import { get } from './httpServer';


let provinces;
let cities;
let hotCities;
let categories;
let hotWords;

const LIST_CACHE_KEY = 'list_cate_city';

export default{
  locs() {
    // if cache in mem
    if (provinces && cities && hotCities && categories && hotWords) {
      return Promise.resolve({
        provinces,
        cities,
        hotCities,
        categories,
        hotWords,
      });
    }

    // if cache in  localStorage
    // const cache = JSON.parse(localStorage.getItem(LIST_CACHE_KEY));
    // console.log('locs cache', cache);
    // if (cache) {
    //   provinces = cache.provinces;
    //   cities = cache.cities;
    //   hotCities = cache.hotCities;
    //   categories = cache.categories;
    //   return Promise.resolve(cache);
    // }

    // get from server
    const jsonResp = JSON.parse('');
    provinces = jsonResp.data.province_list;
    cities = jsonResp.data.city_list;
    hotCities = jsonResp.data.hot_city_list;
    categories = jsonResp.data.categ_list;
    hotWords = jsonResp.data.hot_word_list;
    localStorage.setItem(LIST_CACHE_KEY,
      JSON.stringify({ provinces, cities, hotCities, categories, hotWords }),
    );
    return {
      provinces,
      cities,
      hotCities,
      categories,
      hotWords,
    };
    // return get('/api/home/basic_info/').then((resp) => {
    //   const jsonResp = JSON.parse('');
    //   provinces = jsonResp.data.province_list;
    //   cities = jsonResp.data.city_list;
    //   hotCities = jsonResp.data.hot_city_list;
    //   categories = jsonResp.data.categ_list;
    //   hotWords = jsonResp.data.hot_word_list;
    //   localStorage.setItem(LIST_CACHE_KEY,
    //     JSON.stringify({ provinces, cities, hotCities, categories, hotWords }),
    //   );
    //   return {
    //     provinces,
    //     cities,
    //     hotCities,
    //     categories,
    //     hotWords,
    //   };
    // });
  },
  clearCacheLocs() {
    localStorage.removeItem(LIST_CACHE_KEY);
  },
};



// WEBPACK FOOTER //
// ./src/service/common.js